import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  LoopFieldsSet,
  Backdrop,
  LogoLoader,
  useFormHandler,
  NewTab,
} from "../../../../components";
import { v4 as uuidv4 } from "uuid";
import {
  MonsterEducationLevel,
  MonsterRadiusOptions,
  MonsterPowerSearchTravelRequirementsOptions,
  MonsterPowerSearchTenureOptions,
  ClearanceLeveloptions,
  optionValuescitizen,
  MonsterSearchResumeUpdatedOptions,
} from "../../../../assets/data/enumData";
import RecentHistory from "../CommonJobBoardTabs/RecentHistory";
import SavedHistory from "../CommonJobBoardTabs/SavedHistory";
import { showToast } from "../../../../components";
import { getMonsterApplicantsDataStart } from "../../../../redux/slices/internalDbES/internalDbESlice";
import { useDispatch, useSelector } from "react-redux";
import SearchResults from "../SearchResults";
import {
  getCountries,
  getLocations,
} from "../../../../redux/slices/internalDbES/internalDbESApi";
import { normalizeQuotes } from "../../../../utils/common";
const PowerSearch = ({ loadMonster, saveAccessId, setShowButtons }) => {
  setShowButtons(true);
  const dispatch = useDispatch();
  const [advancedSearch, setAdvancedSearch] = useState(false);
  const [requestBody, setRequestBody] = useState(null);
  const [selectedCountryId, setSelectedCountryId] = useState({});
  const [searchApplicant, setSearchApplicant] = useState(false);
  const { loading } = useSelector((state) => state.internalDbES);
  const { user } = useSelector((state) => state.auth);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCountryCode, setSelectedCountryCode] = useState(null);
  const [locationTypingValue, setLocationTypingValue] = useState({});
  const [locations, setLocations] = useState([]);
  const safeDecode = (v) => {
    try {
      return typeof v === "string" ? decodeURIComponent(v) : v;
    } catch {
      return v;
    }
  };
  const handleSelect = ({ title, filterTerms = {} }) => {
    const decodePowerSearchSkills = (skills) => {
      if (!Array.isArray(skills) || skills.length === 0) return [];

      return skills
        .map((skill) => {
          if (typeof skill !== "string") return null;

          // "React%2520JS req"
          const [encodedValue, req = "nth"] = skill.split(" ");

          try {
            const decodedValue = decodeURIComponent(
              decodeURIComponent(encodedValue),
            );

            return {
              value: decodedValue,
              req,
            };
          } catch {
            return {
              value: encodedValue,
              req,
            };
          }
        })
        .filter(Boolean);
    };

    let skillsData = [{ id: uuidv4(), skillKeywords: "", req: "nth" }];

    if (filterTerms?.sk) {
      let decodedSkills = [];

      if (Array.isArray(filterTerms.sk)) {
        // Decode array like ["React%2520JS req"]
        decodedSkills = decodePowerSearchSkills(filterTerms.sk.flat(Infinity));
      } else if (typeof filterTerms.sk === "string") {
        // Handle comma-separated string
        decodedSkills = decodePowerSearchSkills(
          filterTerms.sk
            .split(",")
            .map((s) => s.trim())
            .filter(Boolean),
        );
      }

      if (decodedSkills.length > 0) {
        skillsData = decodedSkills.map((skill) => ({
          id: uuidv4(),
          skillKeywords: skill.value,
          req: skill.req || "nth",
        }));
      }
    }
    // setLocationTypingValue(safeDecode(filterTerms?.loc)?.replace(/-\d+$/, ""));
    const decodedLocations = filterTerms?.loc
      ? safeDecode(filterTerms.loc)
          .split("+")
          .map((item) => {
            const [zip, miles] = item.split("-");
            return {
              id: uuidv4(),
              zip: zip ?? "",
              miles: miles ?? 50,
            };
          })
      : [{ id: uuidv4(), zip: "", miles: 50 }];

    const typingMap = {};
    decodedLocations.forEach((l, idx) => {
      if (l.zip) typingMap[idx] = l.zip;
    });

    setLocationTypingValue(typingMap);
    
    const mapped = {
      searchType: filterTerms?.searchType ?? "Boolean Search",
      // jobDetails: [{ id: uuidv4(), jobTitle: "" }],
      jobDetails: filterTerms?.jt
        ? safeDecode(filterTerms?.jt)
            .split(",")
            .map((job) => ({
              id: uuidv4(),
              jobTitle: job.trim(),
            }))
        : [{ id: uuidv4(), jobTitle: "" }],
      keywords: "",
      skills: skillsData, // [{ id: uuidv4(), skillKeywords: filterTerms?.sk ?? "" }],
      //   location: filterTerms?.loc
      // ? [{ id: uuidv4(), zip: safeDecode(filterTerms?.loc)?.replace(/-\d+$/, "") ?? "", miles: "" }]
      // : [{ id: uuidv4(), zip:  "", miles: "" }],
      location: filterTerms?.loc
        ? safeDecode(filterTerms.loc)
            .split("+") // split multiple locations
            .map((item) => {
              const [zip, miles] = item.split("-");
              return {
                id: uuidv4(),
                zip: zip ?? "",
                miles: miles ?? 50,
              };
            })
        : [{ id: uuidv4(), zip: "", miles: 50 }],
      country: filterTerms?.country === 840 ? "United States" : "Canada",
      distance: filterTerms?.radius ?? "",
      degree: filterTerms?.edumjr ?? "",
      highEducation: filterTerms?.minedulvid ?? "",
      experience: filterTerms?.yex ?? "",
      salaryType: filterTerms?.salaryType ?? "",
      resumeUpdated:filterTerms?.mdatemaxage === 1576800 ? 0 : filterTerms?.mdatemaxage / 1440,
      salaryLevel: filterTerms?.salaryLevel ?? "",
      desiredJobDuration: filterTerms?.ten ?? "",
      willingToTravel: filterTerms?.wtt && filterTerms?.wtt,
      jobType: filterTerms?.tjtid
        ? String(filterTerms.tjtid)
            .split(",")
            .map(Number)
            .filter((n) => !isNaN(n))
        : [],
      relocation: filterTerms?.relo ? ["relocate"] : [],
      citizenship: filterTerms?.lstat
        ? String(filterTerms.lstat).split(", ").filter(Boolean)
        : [],
      securityClearance: filterTerms?.gsc
        ? String(filterTerms.gsc)
            .split(",")
            .map(Number)
            .filter((n) => !isNaN(n))
        : [],
    };

    setFormData({
      ...initialFormData,
      ...mapped,
    });
    setSelectedTitle(title);
  };

  const initialFormData = {
    searchType: "Boolean Search",
    jobDetails: [{ id: uuidv4(), jobTitle: "" }],
    keywords: "",
    // skills: [{ id: uuidv4(), skillKeywords: "" }],
    skills: [{ id: uuidv4(), skillKeywords: "", req: "nth" }],
    location: [{ id: uuidv4(), zip: "", miles: 50 }],
    country: "United States",
    distance: 50,
    experience: "",
    degree: "",
    resumeUpdated: 0,
    highEducation: "",
    salaryType: "year",
    includeDetails: "1",
    salaryLevel: "",
    desiredJobDuration: "",
    willingToTravel: "",
    jobType: [],
    relocation: [],
    citizenship: [],
    securityClearance: [],
  };

  const { formData, errors, handleChange, setFormData } = useFormHandler(
    initialFormData,
    {},
  );

  /** ---- Dynamic Add/Remove Handlers ---- **/
  const addJobTitle = () =>
    setFormData({
      ...formData,
      jobDetails: [...formData.jobDetails, { id: uuidv4(), jobTitle: "" }],
    });

  const removeJobTitle = (id) =>
    formData.jobDetails.length > 1 &&
    setFormData({
      ...formData,
      jobDetails: formData.jobDetails.filter((d) => d.id !== id),
    });

  // const addSkill = () =>
  //   setFormData({
  //     ...formData,
  //     skills: [...formData.skills, { id: uuidv4(), skillKeywords: "" }],
  //   });
  const addSkill = () =>
    setFormData({
      ...formData,
      skills: [
        ...formData.skills,
        { id: uuidv4(), skillKeywords: "", req: "nth" },
      ],
    });

  const removeSkill = (id) =>
    formData.skills.length > 1 &&
    setFormData({
      ...formData,
      skills: formData.skills.filter((d) => d.id !== id),
    });

  const addLocation = () =>
    setFormData({
      ...formData,
      location: [...formData.location, { id: uuidv4(), zip: "", miles: "" }],
    });

  // const removeLocation = (id) =>
  //   formData.location.length > 1 &&
  //   setFormData({
  //     ...formData,
  //     location: formData.location.filter((d) => d.id !== id),
  //   });

  const removeLocation = (id, index) => {
    if (formData.location.length > 1) {
      setFormData({
        ...formData,
        location: formData.location.filter((d) => d.id !== id),
      });

      setLocationTypingValue((prev) => {
        const copy = { ...prev };
        delete copy[index];
        return copy;
      });
    }
  };

  const handleMonsterSearch = ({ title, filterTerms }) => {
    handleSearch(title, filterTerms);
    setSelectedTitle("");
   };

  //   const formatPowerSearchSkillgs = (skills) => {
  //   if (!skills || skills.length === 0) return '';
  //   const monsterEncode = str => encodeURIComponent(encodeURIComponent(str.trim()));
  //   const processed =skills
  //     .filter(skill => skill.value && skill.value.trim())
  //     .map(skill => {
  //       const encodedValue = skill.value.trim() ? monsterEncode(skill.value) : '';
  //       return `${encodedValue} ${skill?.req||"nth"}`;
  //     });
  //   // If no skills had a value, return a single empty string
  //   if (processed.length === 0) {
  //     return '';
  //   }
  //   return processed;
  // };

  const formatMonsterSkills = (skills) => {
    if (!Array.isArray(skills) || skills.length === 0) return "";

    const doubleEncode = (str) =>
      encodeURIComponent(encodeURIComponent(str.trim()));

    const processed = skills
      .map((skill) => {
        // Case 1: skill is a string
        if (typeof skill === "string" && skill.trim()) {
          return `${doubleEncode(skill)} nth`;
        }

        // Case 2: skill is an object { value, req }
        if (skill?.value && skill.value.trim()) {
          return `${doubleEncode(skill.value)} ${skill?.req || "nth"}`;
        }

        return null;
      })
      .filter(Boolean);

    return processed.length > 0 ? processed : "";
  };

  // console.log(formData.keywords);
  /** ---- Search Handler ---- **/
  const handleSearch = async (title, filterTerms) => {
    const sampleSkills = [
      { value: "JavaScript", req: "must" },
      { value: "React JS", req: "nice" },
      { value: " Node.js ", req: "must" },
      { value: "  ", req: "optional" }, // should be filtered out
      { value: "", req: "must" }, // should be filtered out
    ];

    if (formData.searchType === "Semantic") {
      if (
        (!formData.jobDetails ||
          formData.jobDetails.length === 0 ||
          !formData.jobDetails.some(
            (job) => job.jobTitle && job.jobTitle.trim() !== "",
          )) &&
        !title &&
        !selectedTitle
      ) {
        showToast("Please enter a Job Title or Keyword.", "error");
        return;
      }
      const keyword = formData.jobDetails[0].jobTitle || title || selectedTitle;
      const openParen = (keyword.match(/\(/g) || []).length;
      const closeParen = (keyword.match(/\)/g) || []).length;

      if (openParen !== closeParen) {
        showToast("Invalid keyword syntax: missing ')'.", "error", 2000);
        return;
      }

      // check unbalanced double quotes
      const quotes = (keyword.match(/"/g) || []).length;

      if (quotes % 2 !== 0) {
        showToast('Invalid keyword syntax: missing closing "', "error", 2000);
        return;
      }
    } else if (formData.searchType === "Boolean Search") {
      if (
        (!formData.keywords || formData.keywords.trim() === "") &&
        !title &&
        !selectedTitle
      ) {
        showToast("Please enter a Boolean search keyword.", "error");
        return;
      }
      const keyword = formData?.keywords || title || selectedTitle;
      const openParen = (keyword.match(/\(/g) || []).length;
      const closeParen = (keyword.match(/\)/g) || []).length;

      if (openParen !== closeParen) {
        showToast("Invalid keyword syntax: missing ')'.", "error", 2000);
        return;
      }

      // check unbalanced double quotes
      const quotes = (keyword.match(/"/g) || []).length;

      if (quotes % 2 !== 0) {
        showToast('Invalid keyword syntax: missing closing "', "error", 2000);
        return;
      }
    } else {
      if (
        !(
          (formData.jobDetails &&
            formData.jobDetails.some(
              (job) => job.jobTitle && job.jobTitle.trim() !== "",
            )) ||
          title ||
          selectedTitle
        )
      ) {
        showToast("Job Title or keyword is required!", "error");
        return;
      }
    }
    // const skillsArray =
    //   formData.skills?.map((s) => s.skillKeywords?.trim()).filter(Boolean) ||
    //   [];

    const skillsArray =
      formData.skills
        ?.filter((s) => s.skillKeywords?.trim())
        .map((s) => ({
          value: s.skillKeywords.trim(),
          req: s.req || "nth",
        })) || [];

    // Build the request body dynamically
    let booleanSearchTitle;
    let powerSearchTitle;
    if (formData.searchType == "Boolean Search") {
      booleanSearchTitle = selectedTitle || title;
      powerSearchTitle = "";
    } else {
      booleanSearchTitle = "";
      powerSearchTitle = selectedTitle || title;
    }
    // const [state, city, zipCode] = locationTypingValue.split(",");

    // const distance = formData.distance || 50;

    // const locationParts = [state, city, zipCode].filter(Boolean);

    // const locationValue = locationParts.length
    //   ? `${locationParts.join(",")}-${distance}`
    //   : "";

    const locationValue = formData.location
      .map((l) => {
        if (!l.zip) return null;
        const miles = l.miles || formData.distance || 50;
        return `${l.zip}-${miles}`;
      })
      .filter(Boolean)
      .join("+");

    // console.log("locationValue",locationValue);

    const newRequestBody = {
      accessId: saveAccessId,
      searchType: "power",
      payload: {
        query: {
          // jt: (formData.jobDetails?.length || powerSearchTitle) ? formData.jobDetails
          //   .map((item) => item.jobTitle?.trim())
          //   .filter(Boolean)
          //   .join(", ") || powerSearchTitle : "",
          jt:
            formData.jobDetails?.length || powerSearchTitle
              ? encodeURIComponent(
                  formData.jobDetails
                    ?.map((item) => item.jobTitle?.trim())
                    .filter(Boolean)
                    .join(", ") || powerSearchTitle,
                )
              : "",

          // bkeyword: formData.keywords?.trim() || booleanSearchTitle || "",
          bkeyword: encodeURIComponent(
            formData.keywords?.trim() || booleanSearchTitle || "",
          ),

          // sk: formData.skills
          //   ?.map((s) => s.skillKeywords?.trim())
          //   .filter(Boolean)
          //   .join(", ") || "",
          // sk: skillsArray?.length > 0 ? skillsArray : "",
          sk: formatMonsterSkills(skillsArray),
          searchType: formData.searchType,
          yex: formData.experience,
          salaryType: formData.salaryType,
          salaryLevel: formData.salaryLevel,
          ten: formData.desiredJobDuration,
          wtt: formData.willingToTravel || 1,
          radius: formData.distance || 50,
          edumjr: formData.degree || "",
          tsni: Number(formData.includeDetails) || "",
          mdatemaxage:
            formData.resumeUpdated === 0
              ? 1576800
              : 1440 * formData.resumeUpdated,
          minedulvid: formData.highEducation || "",
          // location: `${state},${city}-${zipCode}`,
          // location:
          //   state && city && zipCode
          //     ? `${state},${city}-${zipCode}`
          //     : "",
          //     radius: formData.distance || 50,
          // location:
          //   state && city && zipCode
          //     ? `${state},${city},${zipCode}-${formData.distance || 50}`
          //     : "",

          // location: locationParts.length
          //   ? `${locationParts.join(",")}-${distance}`
          //   : "",
          loc: encodeURIComponent(locationValue) || "US",

          // country: 'US',
          country: Number(selectedCountryCode) || "US",
          relo: (formData.relocation?.includes("relocate") && true) || "",
          tjtid: formData.jobType?.filter(Boolean).join(", ") || "",
          lstat: formData.citizenship?.filter(Boolean).join(", ") || "",
          gsc: formData.securityClearance?.filter(Boolean).join(", ") || "",
          ...filterTerms,
        },
        page: 1,
        lim: 25,
        source: 4,
        addedBy: user?.data?.uiid,
      },

    };

    // console.log("search", newRequestBody);

    try {
      setRequestBody({...newRequestBody});
      // console.log("Power Search payload", newRequestBody);
      dispatch(
        getMonsterApplicantsDataStart({
          ...newRequestBody,
          onSuccess: () => {
            setSearchApplicant((prev) => !prev);
            setFormData(initialFormData);
            setLocationTypingValue("");
            setSelectedTitle("");
          },
        }),
      );
    } catch (error) {
      console.error("Monster search error:", error);
    }
  };

  const monsterMenus = [
    {
      title: "Recent History",
      page: (
        <RecentHistory
          board="monster"
          subBoard="power"
          onSelect={handleSelect}
          onClick={handleMonsterSearch}
        />
      ),
      type: "main",
    },
    {
      title: "Saved History",
      page: (
        <SavedHistory
          board="monster"
          subBoard="power"
          onSelect={handleSelect}
          onClick={handleMonsterSearch}
        />
      ),
      type: "main",
    },
  ];

  //  useEffect(() => {
  //    const [city, state, zip] = (locationTypingValue ?? "").split(",");
  //    if (city && state) return;

  //    const delay = setTimeout(async () => {
  //      setLocations([])
  //      const response = await getLocations({ locationValue: locationTypingValue, country: selectedCountryId?._id, limit: 500, });
  //      if (response?.success) {
  //       //  const uniqueStates = [...new Set((response?.data?.data || []).map(item => item.stateName))];
  //        const locationData = response?.data?.data.flatMap((item) => {
  //          const name = item.name ?? "";
  //          const state = item.stateName ?? "";
  //          if (Array.isArray(item.zipCode)) {
  //            return item.zipCode.map((zc) => `${name},${state},${zc}`);
  //          }
  //          return [`${name},${state},${item.zipCode ?? ""}`];
  //        });
  //       //  setLocations([ ...uniqueStates,...locationData])
  //        const search = locationTypingValue.toLowerCase();

  //     // const statesStartsWith = uniqueStates.filter((item) =>
  //     //   item.toLowerCase().startsWith(search)
  //     // );
  //     // const statesContains = uniqueStates.filter(
  //     //   (item) =>
  //     //     item.toLowerCase().includes(search) &&
  //     //     !item.toLowerCase().startsWith(search)
  //     // );
  //     const locationsStartsWith = locationData.filter((item) =>
  //       item.toLowerCase().startsWith(search)
  //     );
  //     const locationsContains = locationData.filter(
  //       (item) =>
  //         item.toLowerCase().includes(search) &&
  //         !item.toLowerCase().startsWith(search)
  //     );
  //     // statesStartsWith.sort((a, b) => a.localeCompare(b));
  //     // statesContains.sort((a, b) => a.localeCompare(b));
  //     locationsStartsWith.sort((a, b) => a.localeCompare(b));
  //     locationsContains.sort((a, b) => a.localeCompare(b));
  //     setLocations([
  //       // ...statesStartsWith,
  //       ...locationsStartsWith,
  //       // ...statesContains,
  //       ...locationsContains,
  //     ]);
  //      }
  //    }, 0);

  //    return () => clearTimeout(delay);
  //  }, [locationTypingValue, formData?.country]);

  //  useEffect(() => {
  //    if (!formData?.country) return;

  //    const delay = setTimeout(async () => {
  //      const response = await getCountries({ name: formData?.country });
  //      const countries = response.data.data
  //      const desiredCountryId = countries[0]
  //      setSelectedCountryId(desiredCountryId);
  //      setSelectedCountryCode(desiredCountryId?.numericCode);
  //      setLocationTypingValue("");
  //    }, 0);

  //    return () => clearTimeout(delay);
  //  }, [formData?.country]);

  useEffect(() => {
    if (!locationTypingValue) return;
    Object.entries(locationTypingValue).forEach(([index, value]) => {
      if (!value) return;

      const [city, state, zip] = value.split(",");
      if (city && state && zip) return;

      const delay = setTimeout(async () => {
        const response = await getLocations({
          locationValue: value,
          country: selectedCountryId?._id,
          limit: 500,
        });

        if (response?.success) {
          const locationData = response?.data?.data.flatMap((item) => {
            const name = item.name ?? "";
            const state = item.stateName ?? "";

            if (Array.isArray(item.zipCode)) {
              return item.zipCode.map((zc) => `${name},${state},${zc}`);
            }
            return [`${name},${state},${item.zipCode ?? ""}`];
          });

          const search = value.toLowerCase();

          const startsWith = locationData
            .filter((i) => i.toLowerCase().startsWith(search))
            .sort((a, b) => a.localeCompare(b));

          const contains = locationData
            .filter(
              (i) =>
                i.toLowerCase().includes(search) &&
                !i.toLowerCase().startsWith(search),
            )
            .sort((a, b) => a.localeCompare(b));

          setLocations([...startsWith, ...contains]);
        }
      }, 300);

      return () => clearTimeout(delay);
    });
  }, [locationTypingValue, formData?.country]);

  useEffect(() => {
    if (!formData?.country) return;

    const delay = setTimeout(async () => {
      const response = await getCountries({ name: formData?.country });
      const countries = response?.data?.data;
      const desiredCountryId = countries[0];
      setSelectedCountryId(desiredCountryId);
      setSelectedCountryCode(desiredCountryId?.numericCode);
      setLocationTypingValue({});
    }, 0);

    return () => clearTimeout(delay);
  }, [formData?.country]);

  /** ---- JSX ---- **/
  return !searchApplicant ? (
    <div>
      <div className="m-2 flex flex-1 md:flex-col lg:flex-row rounded-md overflow-y-auto">
        <div className="flex-1 inner-section px-3 py-3 rounded-md m-4 overflow-y-auto">
          <p className="font-[500]">Power Resume Search</p>

          {/* Search Type */}
          <FormFieldSet
            noTitle
            type="radio"
            options={[
              { label: "Semantic", value: "Semantic" },
              { label: "Boolean Search", value: "Boolean Search" },
            ]}
            value={formData.searchType}
            onChange={(e) => handleChange("searchType", e.target.value)}
            error={errors.searchType}
          />

          {/* SEMANTIC Search */}
          {formData?.searchType === "Semantic" && (
            <>
              {/* Job Titles */}
              <LoopFieldsSet
                title="Job Titles"
                titleConfig={{
                  tag: "h6",
                }}
                data={formData?.jobDetails}
                onAdd={addJobTitle}
                onRemove={removeJobTitle}
                maxItems={10}
                gridCols="grid-cols-1"
                addButtonTitle="Add More Job Titles"
                renderFields={(detail, index) => (
                  <div className="col-span-9">
                    <FormFieldSet
                      type="text"
                      title="Job Title"
                      placeholder="Job Title"
                      value={detail?.jobTitle || selectedTitle}
                      onChange={(value) => {
                        handleChange(`jobDetails[${index}].jobTitle`, value);
                        setSelectedTitle("");
                      }}
                      error={errors?.jobDetails?.[index]?.jobTitle}
                      shadow
                    />
                    <p className="mt-1 mb-2 text-xs">
                      (e.g., Sales, Accountant)
                    </p>
                  </div>
                )}
              />

              {/* Skill Keywords */}
              {/* Skill Keywords + Required Switch */}
              <LoopFieldsSet
                title="Skills / Keywords"
                titleConfig={{
                  tag: "h6",
                }}
                data={formData?.skills}
                onAdd={addSkill}
                onRemove={removeSkill}
                maxItems={10}
                gridCols="grid-cols-1"
                addButtonTitle="Add Another Skill or Keyword"
                renderFields={(skill, index) => (
                  <>
                    <div className="col-span-8">
                      <FormFieldSet
                        type="text"
                        title="Skill / Keyword"
                        placeholder="e.g. Java, Telesales, SOX"
                        value={skill?.skillKeywords}
                        onChange={(value) =>
                          handleChange(`skills[${index}].skillKeywords`, value)
                        }
                        shadow
                      />
                    </div>

                    {/* Switch */}
                    <div className="col-span-2 flex items-center px-2">
                      <div className="inline-flex items-center gap-1">
                        <FormFieldSet
                          type="toggle"
                          title=""
                          isChecked={skill?.req === "req"}
                          onChange={(checked) =>
                            handleChange(
                              `skills[${index}].req`,
                              checked ? "req" : "nth",
                            )
                          }
                        />

                        {/* Show req/nth right next to toggle */}
                        <span className="text-sm text-gray-600 pt-4">
                          {skill?.req === "req" ? "req" : "nth"}
                        </span>
                      </div>
                    </div>
                  </>
                )}
              />
            </>
          )}

          {/* BOOLEAN Search */}
          {formData.searchType === "Boolean Search" && (
            <>
              <FormFieldSet
                title="Keywords"
                placeholder="Keywords"
                value={formData?.keywords || selectedTitle}
                onChange={(value) =>
                  handleChange("keywords", normalizeQuotes(value))
                }
                shadow={true}
              />

              <div className="mt-3">
                {/* Years of Experience */}
                <FormFieldSet
                  title="Years of Experience"
                  placeholder="Years of Experience"
                  value={formData.experience}
                  onChange={(value) => handleChange("experience", value)}
                  shadow={true}
                />
              </div>
            </>
          )}

          {/* Locations */}
          <div className="my-3">
            <h6 className="my-2">Locations</h6>
            <FormFieldSet
              title="Enter city, state, country or zip code"
              // type="select"
              type="countriesUsAndCanada"
              // options={countryMonsterOptions}
              value={formData.country}
              onChange={(value) => handleChange("country", value.value)}
              shadow={true}
            />

            {/* <LoopFieldsSet
            title=" "
            data={formData?.location}
            onAdd={addLocation}
            onRemove={removeLocation}
            maxItems={3}
            gridCols="grid-cols-11"
            addButtonTitle="Add location details"
            renderFields={(loc, index) => (
              <>
                <div className="col-span-5 mx-2">
                  <FormFieldSet
                    noTitle
                    // type="text"
                    placeholder="Zip Code"
                    // value={formData?.zipCode}
                    value={locationTypingValue}
                    // onChange={(value) => handleChange("zipCode", value)}
                    onChange={(value) => {setLocationTypingValue(value);handleChange("location.zip", value)}}
                    error={errors?.zipCode}
                    shadow={true}
                    suggestionsList={locations}
                  />
                </div>
                <div className="col-span-5 mx-2">
                  <FormFieldSet
                    type="select"
                    noTitle
                    placeholder="Miles away"
                    options={MonsterRadiusOptions}
                    value={formData?.distance}
                    onChange={(value) => handleChange("distance", value)}
                    error={errors?.distance}
                    shadow={true}
                  />
                </div>
              </>
            )}
          /> */}
            <LoopFieldsSet
              title=" "
              data={formData.location}
              onAdd={addLocation}
              onRemove={removeLocation}
              maxItems={3}
              gridCols="grid-cols-11"
              addButtonTitle="Add location details"
              renderFields={(loc, index) => (
                <>
                  {/* ZIP */}
                  <div className="col-span-5 mx-2">
                    <FormFieldSet
                      noTitle
                      placeholder="Zip Code"
                      value={locationTypingValue[index] ?? loc.zip ?? ""}
                      onChange={(value) => {
                        setLocationTypingValue((prev) => ({
                          ...prev,
                          [index]: value,
                        }));
                        if (!value || value.trim() === "") {
                          handleChange(`location[${index}].zip`, "");
                        } else {
                          handleChange(`location[${index}].zip`, value);
                        }
                        setLocations([]);
                      }}
                      shadow
                      suggestionsList={locations}
                    />
                  </div>

                  {/* MILES */}
                  <div className="col-span-5 mx-2">
                    <FormFieldSet
                      type="select"
                      noTitle
                      placeholder="Miles away"
                      options={MonsterRadiusOptions}
                      value={loc.miles}
                      onChange={(value) =>
                        handleChange(`location[${index}].miles`, value)
                      }
                      shadow
                    />
                  </div>
                </>
              )}
            />
          </div>

          <FormFieldSet
            title="Resume Updated"
            placeholder="Resume Updated"
            options={MonsterSearchResumeUpdatedOptions}
            type="select"
            value={formData?.resumeUpdated}
            onChange={(value) => handleChange("resumeUpdated", value)}
            // error={errors?.from}
            shadow={true}
          />
          <div className="mt-3">
            <FormFieldSet
              title="Education"
              placeholder="Minimun Education Level"
              options={MonsterEducationLevel}
              type="select"
              value={formData?.highEducation}
              onChange={(value) => handleChange("highEducation", value)}
              // error={errors?.from}
              shadow={true}
            />
          </div>

          <FormFieldSet
            // noTitle
            title=" "
            type="text"
            placeholder="Degree/Major"
            value={formData?.degree}
            // value={locationTypingValue}
            onChange={(value) => handleChange("degree", value)}
            // onChange={(value) => setLocationTypingValue(value)}
            // error={errors?.zipCode}
            // shadow={true}
            // suggestionsList={locations}
          />
          <p className="mt-3 text-xs">(e.g., MBA, MS Math, MSCS, English)</p>

          <FormFieldSet
            type="radio"
            title="Maximum Salary"
            name="salaryType"
            options={[
              { label: "Per Year", value: "year" },
              { label: "Per Hour", value: "hour" },
            ]}
            value={formData.salaryType}
            onChange={(e) => handleChange("salaryType", e.target.value)}
          />
          <FormFieldSet
            type="select"
            noTitle
            placeholder="Salary Level"
            options={[
              { label: "$ 30000", value: "$ 30000" },
              { label: "$ 40000", value: "$ 40000" },
              { label: "$ 50000", value: "$ 50000" },
              { label: "$ 60000", value: "$ 60000" },
              { label: "$ 70000", value: "$ 70000" },
              { label: "$ 80000", value: "$ 80000" },
              { label: "$ 90000", value: "$ 90000" },
            ]}
            value={formData.salaryLevel}
            onChange={(value) => handleChange("salaryLevel", value)}
          />
          <FormFieldSet
            type="checkbox"
            size="md"
            noTitle
            placeholder="Select"
            options={[
              {
                label: "Include candidates without salary information",
                value: "1",
              },
            ]}
            values={formData?.includeDetails}
            onChange={(value) => handleChange("includeDetails", value)}
            error={errors?.includeDetails}
          />
          <FormFieldSet
            type="checkbox"
            size="md"
            title="Job Type"
            options={[
              { label: "Full-Time", value: 1 },
              { label: "Part-time", value: 2 },
              { label: "Intern", value: 3 },
              { label: "Temporary/Contract", value: 4 },
              { label: "Seasonal", value: 5 },
            ]}
            values={formData.jobType}
            onChange={(newValues) => handleChange("jobType", newValues)}
            multiple
          />

          <div className="my-2 mt-3 ">
            <FormFieldSet
              type="select"
              title="Desired Job Duration"
              placeholder="Select Desired Job Duration"
              options={MonsterPowerSearchTenureOptions}
              value={formData.desiredJobDuration}
              onChange={(value) => handleChange("desiredJobDuration", value)}
              shadow={true}
            />
            <p className="text-sm text-netrals-300 mt-1">
              Select a desired average tenure
            </p>
          </div>

          <div className="my-2">
            <FormFieldSet
              type="select"
              title="Willing To Travel"
              placeholder="Select"
              options={MonsterPowerSearchTravelRequirementsOptions}
              value={formData.willingToTravel}
              onChange={(value) => handleChange("willingToTravel", value)} // ✅ update formData
              shadow={true}
            />
          </div>
          <div className="grid grid-cols-2 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-2 my-3">
            <FormFieldSet
              type="checkbox"
              size="md"
              title="Relocation"
              options={[
                {
                  label:
                    "Limit result to job seekers who are willing to relocate",
                  value: "relocate",
                },
              ]}
              values={formData?.relocation || []}
              onChange={(newValues) => handleChange("relocation", newValues)}
              multiple
            />
            <div className="mt-5">
              <FormFieldSet
                type="checkbox"
                size="md"
                title="Citizenship"
                options={optionValuescitizen}
                values={formData?.citizenship || []}
                onChange={(newValues) => handleChange("citizenship", newValues)}
                multiple
              />
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 my-3">
            <FormFieldSet
              type="checkbox"
              size="md"
              title="Security Clearance"
              options={ClearanceLeveloptions}
              values={formData?.securityClearance || []}
              onChange={(newValues) =>
                handleChange("securityClearance", newValues)
              }
              multiple
            />
          </div>

          <div className="flex justify-end">
            {advancedSearch ? (
              <Button
                icon={"add"}
                variant="text"
                title="Hide Advanced Search"
                color="info"
                // className="italic underline underline-offset-2 decoration-2"
                onClick={() => setAdvancedSearch((prev) => !prev)}
              />
            ) : (
              <Button
                icon={"add"}
                variant="text"
                title="Advanced Search"
                color="info"
                // className="italic underline underline-offset-2 decoration-2"
                onClick={() => setAdvancedSearch((prev) => !prev)}
              />
            )}
          </div>
          <div className="flex justify-end gap-4 my-4">
            <Button
              title="Reset"
              variant="outlined"
              size="sm"
              onClick={() => {
                setFormData(initialFormData);
                setSelectedTitle("");
              }}
            />
            <Button
              disabled={!loadMonster && !saveAccessId}
              title="Search"
              size="sm"
              onClick={() => handleSearch()}
            />
          </div>
        </div>

        {/* Right Side Tabs */}
        <div className="flex flex-1 flex-col mx-2 overflow-y-auto">
          <p className="font-[600] mx-2">Strings History</p>
          <div className="flex flex-1 shadow m-2 p-3">
            <NewTab
              tabs={monsterMenus}
              color="gray"
              variant="text"
              activeVariant="text"
            />
          </div>
        </div>
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  ) : (
    <div className="flex flex-1 flex-col overflow-hidden mt-2">
      <SearchResults
        source={3}
        query={requestBody}
        loading={loading}
        setSearchApplicant={setSearchApplicant}
        setShowButtons={setShowButtons}
      />
    </div>
  );
};

export default PowerSearch;
